import { render, staticRenderFns } from "./FormCampoAdicional.vue?vue&type=template&id=35ae664e"
import script from "./FormCampoAdicional.vue?vue&type=script&lang=js"
export * from "./FormCampoAdicional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports